import type {ButtonProps} from '@chakra-ui/react';
import {Button, forwardRef, useEditableControls} from '@chakra-ui/react';
import {useFormContext} from 'react-hook-form';

export const EditableSubmitButton = forwardRef<ButtonProps, 'button'>((props, ref) => {
  const {getSubmitButtonProps} = useEditableControls();
  const {
    formState: {isValid, isDirty},
  } = useFormContext();

  const submitButtonProps = getSubmitButtonProps(props, ref);
  const disabled = submitButtonProps.disabled || !isValid || !isDirty;

  return (
    <Button variant={`primary`} size={`sm`} {...submitButtonProps} isDisabled={disabled} {...props}>
      Save
    </Button>
  );
});
